import React from "react";
import { Component } from "react";
import axios from "axios";
import { Input, Button } from "mdbreact";
import domain from ".././../../../domain";
const moment = require("moment");
let enumerateDaysBetweenDates = function (startDate, endDate) {
  var dates = [];

  var currDate = moment(startDate).startOf("day");
  var lastDate = moment(endDate).startOf("day");
  console.log(lastDate);
  dates.push(currDate.toDate());
  while (currDate.add(1, "days").diff(lastDate) <= 0) {
    console.log(currDate.toDate());
    dates.push(currDate.clone().toDate());
  }
  console.log(dates);
  return dates;
};
export default class AddSession extends Component {
  constructor(props) {
    super(props);
    this.state = {
      course: "",
      course_id: "",
      date: "",
      session: "09:15:00-10:45:00",
      lname: "",
      topic: "",
      loading: true,
      error: "",
      data: null,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    console.log(e.target.name + "" + e.target.value);
  };

  componentDidMount() {
    // let courseId = this.props.match.params.id;
    console.log("here");
    axios
      .get(`${domain.DOMAIN}/fetch-course`)
      .then((result) => {
        console.log(result.data);
        this.setState({
          data: result.data,
          course_id: result.data[0].course_id,
          loading: false,
          error: false,
        });
      })
      .catch((error) => {
        console.error("error: ", error);
        this.setState({
          error: `${error}`,
          loading: false,
        });
      });
  }

  insertSchedule = (course) => {
    console.log(course);
    axios({
      method: "post",
      url: `${domain.DOMAIN}/add_session_wise_details`,
      data: course,
    })
      .then((response) => {
        //console.log(response)
        const { err, success, msg } = response.data;

        //console.log(success+msg+err)
        console.log(success);
        console.log(err);

        if (success) {
          console.log("if");
          alert(msg);
          //console.log(this)
          this.props.history.replace("/view-sessions");
        } else {
          console.log("else");
          alert(msg);
        }
      })
      .catch((response) => {
        console.log(response);
      });
  };

  onSubmit(e) {
    e.preventDefault();
    console.log(this.state.session);
    let start = this.state.session.split("-")[0];
    let end = this.state.session.split("-")[1];
    const newSchedule = {
      course_id: this.state.course_id,
      date: this.state.date,
      start_session: start,
      end_session: end,
      topic: this.state.topic,
      lname: this.state.lname,
    };
    let r = window.confirm("Check once again the details before submitting");
    if (r) {
      this.insertSchedule(newSchedule);
    } else {
      return false;
    }
  }
  intialValues = (e) => {
    alert(e.target.name);
    this.setState({
      // course:'',
      //  course_id:'',
      date: "",
      session: "09:15:00-10:45:00",
      lname: "",
      topic: "",
    });
  };

  render() {
    const { loading, error, data } = this.state;
    let options, result;
    if (loading) {
      return <p>Loading ...</p>;
    }
    if (error) {
      return (
        <p>
          There was an error loading the courses. Try again and Check Your
          database server is running or not
        </p>
      );
    }
    if (this.state.data) {
      let startd = moment(data[0].start_date).format("MM/DD/YYYY");
      let endd = moment(data[0].end_date).format("MM/DD/YYYY");
      result = enumerateDaysBetweenDates(startd, endd);
      if (result) {
        options = result.map((dates, key) => {
          return (
            <option key={key} value={moment(dates).format("MM/DD/YYYY")}>
              {moment(dates).format("MM/DD/YYYY")}
            </option>
          );
        });
      }
    }

    return (
      <div>
        <form onSubmit={this.onSubmit.bind(this)}>
          <div className="form-group">
            <label>Choose Course</label>
            <select
              className="form-control"
              id="course"
              name="course"
              onChange={this.handleInputChange}
              value={this.state.course}
            >
              {data.map((course) => (
                <option key={course.course_id} value={course.course_id}>
                  {course.course_id +
                    "_" +
                    course.title +
                    "_" +
                    course.year +
                    "_" +
                    course.start_date +
                    "_" +
                    course.end_date}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Start Time</label>
            <input
              type="time"
              name="start_time"
              onChange={this.handleInputChange}
              value={this.state.start_time}
            />
          </div>
          <div className="form-group">
            <label>End Time</label>
            <input
              type="time"
              name="end_time"
              onChange={this.handleInputChange}
              value={this.state.end_time}
            />
          </div>
          {/* <div className="form-group">
      <label>Session</label>

      <select className="form-control" id="session" name="session" onChange={this.handleInputChange} value={this.state.session}>
          <option value="09:15:00-10:45:00" selected>9:15-10:45 </option>
          <option value="11:00:00-01:00:00" >11:00-1:00</option>
          <option value="02:00:00-03:15:00" >2:00-3:15</option>
          <option value="03:30:00-04:30:00">3:30-4:30</option>
      </select>
    </div> */}
          <select
            className="form-control"
            id="session"
            name="date"
            onChange={this.handleInputChange}
            pattern="[0-9]{0,1}/[0-9]{0,1}/[0-9]{4}"
            validate
            required
          >
            {options}
          </select>
          {/* <Input type="date" value={this.state.date} label="Date" name="date" onChange={this.handleInputChange} pattern="[0-9]{0,1}/[0-9]{0,1}/[0-9]{4}" validate required /> */}
          <Input
            type="text"
            value={this.state.title}
            label="Topic"
            name="topic"
            id="topic"
            onChange={this.handleInputChange}
            validate
            required
          />
          <Input
            type="text"
            label="Lecturer Name"
            value={this.state.lname}
            name="lname"
            id="lname"
            onChange={this.handleInputChange}
            validate
            required
          />
          <Button type="submit">Submit</Button> &nbsp;&nbsp;
          <Button type="reset" name="clear" onClick={this.intialValues}>
            Clear Values
          </Button>
        </form>
      </div>
    );
  }
}
